import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { DefaultChartDTO } from "api";
import { VarianceDropdown, DateRangeDropdown, YearOverYearDropdown, SingleYearByScopeDropdown } from "../../dropdowns";

export const SubTab = ({
  searchFilters,
  setSearchFilters,
  children,
  currentMainTab,
  subTypeChart,
  fiscalYears
}: {
  searchFilters: DefaultChartDTO;
  setSearchFilters: React.Dispatch<React.SetStateAction<DefaultChartDTO>>;
  children?: React.ReactNode;
  currentMainTab: string;
  subTypeChart: string;
  fiscalYears: string[];
}) => {

  useEffect(() => {
    const utilityTypeMap: Record<string, number> = {
      electricity: 1,
      "natural gas": 2,
      water: 5,
      sewer: 8,
    };

    const utilityTypeId = utilityTypeMap[subTypeChart] ?? null;

    setSearchFilters((prev) => {
      const prevId = prev.utilityTypeIds?.[0] ?? null;
      if (prevId === utilityTypeId) return prev; // bail out — same value, no re-render
      return {
        countryRegions: null,
        countries: null,
        siteIds: null,
        facilityTypes: null,
        businessUnits: null,
        scopes: null,
        utilityTypeIds: utilityTypeId !== null ? [utilityTypeId] : null,
        accountNumbers: null,
        meterNumbers: null,
      };
    });
  }, []); // eslint-disable-line

  return (
    <Box>
      {children}
      <Box sx={{ mt: 3, width: "calc(100vw - 145px)", display: "flex", flexDirection: "column", gap: 2 }}>
        <VarianceDropdown searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
        <DateRangeDropdown searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
        <YearOverYearDropdown searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
        <SingleYearByScopeDropdown fiscalYears={fiscalYears} searchFilters={searchFilters} subTypeChart={subTypeChart} currentMainTab={currentMainTab} />
      </Box>
    </Box>
  )
}
